import React, { FC } from 'react';

interface Props {
  white?: boolean;
  minHeight?: string;
}

const Loading: FC<Props> = ({ white = false, minHeight }) => {
  return (
    <div style={minHeight ? { minHeight } : undefined}>
      <div
        className={`spinner ${white ? 'spinner-white' : ''}`}
        style={minHeight ? { margin: 0 } : undefined}
      ></div>
    </div>
  );
};

export default Loading;
